/* eslint-disable react/no-unknown-property */

import { Canvas } from '@react-three/fiber'
import { Bounds, GizmoHelper, OrbitControls, PerspectiveCamera } from '@react-three/drei'
import Gizmo from './Gizmo'
import Design3D from './viewer/Design3D'
import { RootState } from '@/stores'
import { useSelector } from 'react-redux'
import { useRef } from 'react'
import { PerspectiveCamera as PerspectiveCameraType } from 'three'
import type { OrbitControls as OrbitControlsImpl } from 'three-stdlib'


const ViewerScene = () => {
  const design = useSelector((state: RootState) => state.activeDesign.design)
  const selectedCameraControlType = useSelector((state: RootState) => state.selectedCameraControlType.option)

  const cameraRef = useRef<PerspectiveCameraType>(null)
  const orbitRef = useRef<OrbitControlsImpl>(null)

  return (
    <Canvas>
      <color attach="background" args={['#EFEFF1']} />

      <ambientLight intensity={0.5} />

      <directionalLight
        position={[-100, 75, 100]}
        castShadow
        intensity={5}
      />

      <pointLight
        position={[100, -75, -100]}
        decay={0}
        intensity={1}
      />

      <PerspectiveCamera
        makeDefault
        ref={cameraRef}
      />

      {/*
        There is a known issue with CameraControls combined with Bounds
        https://github.com/pmndrs/drei/issues/1408
      */}
      <OrbitControls
        makeDefault
        ref={orbitRef}
        enableZoom={selectedCameraControlType === 'cursor'}
        enablePan={selectedCameraControlType === 'cursor'}
        zoomSpeed={0.75}
        minDistance={20}
        maxDistance={10000}
        target={[0, 0, 0]}
        zoomToCursor
      />

      <GizmoHelper alignment="bottom-left" margin={[50, 50]}>
        <Gizmo />
      </GizmoHelper>

      <Bounds>
        <Design3D
          cameraRef={cameraRef}
          orbitRef={orbitRef}
          design={design}
        />
      </Bounds>
    </Canvas>
  )
}

export default ViewerScene
